module.exports = __webpack_public_path__ + "img/PinkOutline300.50d5b7c3.png";